import type { ComponentPropsWithoutRef } from "react";
import { memo } from "react";

import { twMerge } from "tailwind-merge";

import type { TableProps, TableRowExt } from "../types";

import { Td } from "./td";

type Props<ColumnKey extends string, Row extends TableRowExt<ColumnKey>> = {
  hasTh?: boolean;
  hovered?: boolean;
  row: Row;
} & Pick<TableProps<ColumnKey, Row>, "columns" | "onRowClick">;

export const TrTd = <ColumnKey extends string, Row extends TableRowExt<ColumnKey>>({
  columns,
  hasTh,
  hovered,
  onRowClick,
  row,
}: Props<ColumnKey, Row>) => {
  return (
    <TrUI className={onRowClick && "cursor-pointer"} onClick={() => onRowClick?.(row)}>
      {columns.map((column) => (
        <Td
          column={column}
          hasTh={hasTh}
          hovered={hovered}
          isClicked={!!onRowClick}
          key={column.key}
          row={row}
        />
      ))}
    </TrUI>
  );
};

export const TrUI = (props: ComponentPropsWithoutRef<"tr">) => {
  return <tr {...props} className={twMerge("group", props.className)} />;
};

export const TrTdMemo = memo(TrTd) as typeof TrTd;
